import React from 'react';
import { Button, Col, Form, Row } from 'antd';
import LeaderForm from './LeaderForm';

const LeaderFormList = () => (
  <Form.List name="authorizedToGiveInstruction">
    {(fields, { add, remove }) => (
      <>
        {fields.map((field) => (
          <LeaderForm remove={remove} field={field} key={field.key} />
        ))}
        <Row>
          <Col span={23}>
            <Button className="swiftForm__button" type="dashed" onClick={() => add({})}>
              + Agregar mandatario o persona
            </Button>
          </Col>
        </Row>
      </>
    )}
  </Form.List>
);
export default LeaderFormList;
